/* DOPA: configuração do GSAP que antes ficava inline no theme.liquid.
   Carrega com defer entre animations.min.js e app.js (mesma ordem de antes). */
(function () {
  if (typeof gsap === 'undefined') return;
  gsap.defaults({
    ease: Power4.easeOut
  });
  gsap.config({
    nullTargetWarn: false
  });
  if (typeof ScrollTrigger !== 'undefined') gsap.registerPlugin(ScrollTrigger);
})();
